import util from '@/assets/js/util';
import { useRouter } from "vue-router";
import { authStore } from "@/stores/auth";
import { filterStore } from "@/stores/filter";
import qs from 'qs'


async function getImage(type, axiosInsting, isafeno, id) {
    if (type == "isafe") {
        // return 'https://dev.icore-service.borneo-indobara.com/esimper/employee/preview-photo-profile?isafeno=BC9DE8'
        return 'https://dev.icore-service.borneo-indobara.com/esimper/employee/preview-photo-profile?isafeno=' + isafeno
    } else {
        try {
            // API endpoint to generate the image URL
            const url = "user/image/" + id;

            // Make the API call using axios (replace axiosInsting with your instance name)
            const response = await axiosInsting.get(url);

            // Check if the response has the expected structure and contains the URL
            if (response.status === 200 && response.data && response.data.data && response.data.data.url) {
                return response.data.data.url; // Return the URL from the response
            } else {
                console.error("Failed to retrieve image URL");
                return "";
            }
        } catch (error) {
            console.error("Error in getImageNonIsafe:", error);
            return "";
        }
    }
}

async function doLogout() {
    const auth = authStore();
    const router = useRouter();
    await router.push("/login");
    auth.clear();
    localStorage.clear();
}

async function doLogin(axios) {
    const auth = authStore();
    let dataLogin = qs.stringify({
        'username': process.env.VUE_APP_UGEMS_USERNAME,
        'password': process.env.VUE_APP_UGEMS_PASSWORD,
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'token',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: dataLogin
    };

    await axios.request(config)
        .then((r) => {
            auth.updateJwtUgems(r.data);
        })
        .catch((e) => {
            util.showError(e);
        });
}

async function doSearch(axios, keyword, area, synonym, translate) {
    const auth = authStore();
    if (area == "Area") {
        area = ""
    }
    var result = {}
    result = await axios.post("search_keyword", {
        query_string: keyword,
        top_k: process.env.VUE_APP_UGEMS_TOP_K,
        location: area,
        synonym: synonym,
        translate_only: translate,
    },
        { headers: { 'Authorization': 'Bearer ' + auth.appTokenUgems } }
    ).then(r => {
        return r
    }, e => {
        return e
    })

    return result
}

async function doSearchESB(axios, page, size, status, keyword, location) {
    var url = "insting/list-data?page=" + page + "&size=" + size + "&status=" + status + "&location=" + location + "&keyword=" + keyword
    var result = {}
    result = await axios.get(url, {},
    ).then(r => {
        return r
    }, e => {
        return e
    })

    return result
}

async function submitStatus(axios, id, status, notes, location, keyword) {
    const auth = authStore();
    var result = {}
    result = await axios.post("insting/validation", {
        hazard_id: id,
        status: status,
        notes: notes,
        location: location,
        keyword: keyword,
        isafe_no: (auth.appData.isafe_no != undefined) ? auth.appData.isafe_no : "",
    }
    ).then(r => {
        return r.data
    }, e => {
        return e
    })

    return result
}


async function confirmStatus(axios, id, status, notes, location, keyword) {
    var result = {}
    result = await axios.post("insting/confirm", {
        hazard_id: id,
        status: status,
        notes: notes,
        location: location,
        keyword: keyword,
    }
    ).then(r => {
        return r.data
    }, e => {
        return e
    })

    return result
}

async function deleteStatus(axios, id, notes) {
    var result = {}
    result = await axios.post("insting/delete", {
        hazard_id: id,
        notes: notes,
    }
    ).then(r => {
        return r.data
    }, e => {
        return e
    })

    return result
}

async function getArea(axios) {
    const filter = filterStore();
    var result = {}
    result = await axios.get("insting/get-area", {}).then(r => {
        return r.data
    }, e => {
        return e
    })

    filter.list_area = ["Pilih Lokasi"].concat(result.data);

    return result
}

async function getKontraktor(axios) {
    const filter = filterStore();
    var result = {}
    // filter.set(filter)
    // {{host_insting}}/api/esb/external/kontraktor
    result = await axios.get("external/kontraktor", {}).then(r => {
        return r.data
    }, e => {
        return e
    })

    return result
}

async function getImageNonIsafe(axios) {
    try {
        // API endpoint to generate the image URL
        const url = "user/image/" + data.form.id;
        console.log(url)

        // Make the API call using axios (replace axiosInsting with your instance name)
        const response = await axios.get(url);

        // Check if the response has the expected structure and contains the URL
        if (response.status === 200 && response.data && response.data.data && response.data.data.url) {
            return response.data.data.url; // Return the URL from the response
        } else {
            console.error("Failed to retrieve image URL");
            return "";
        }
    } catch (error) {
        console.error("Error in getImageNonIsafe:", error);
        return "";
    }
}

async function getPhoto(axios, isafeno) {
    if (isafeno == '') {
        return await getImageNonIsafe()
    } else {
        return await axios.get(process.env.VUE_APP_PHOTO_URL + '/esimper/employee/preview-photo-profile?isafeno=' + isafeno, {
            responseType: 'blob' // Ensure the response is treated as a binary blob
        }).then(r => {
            return URL.createObjectURL(r.data); // Convert the blob to an object URL
        }, e => {
            return e;
        });
    }
}

export default {
    getImage,
    doLogout,
    doSearch,
    doLogin,
    getArea,
    getKontraktor,
    doSearchESB,
    submitStatus,
    deleteStatus,
    confirmStatus,
    getPhoto,
}